<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item">
        <div class="date-grid">
          <label for="startDatePicker">Stock Allocation Date</label>
          <div class="date-search-container">
            <input
                type="date"
                v-model="startDate"
                class="search-input"
            />
            <button @click="performSearch" class="btn button-default">Search</button>
          </div>
        </div>
        <button type="button" class="btn button-default new-stock-allocation-btn mt-4" @click="newStockAllocation">
          Create Stock Allocation
        </button>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr class="border-bottom-primary">
            <th scope="col">Dealer | DSR</th>
            <th scope="col">Stock Allocation No</th>
            <th scope="col">Date</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(item, index) in bootstraplist"
              :key="index"
              :class="item.borderColor"
          >
            <td>{{ item.dealer_name || '' }} {{ item.sales_rep_name || '' }}</td>
            <td>{{ item.stock_allocations_no }}</td>
            <td>{{item.created_at }}</td>
            <td class="mt-1">
              <span :class="getStatusLabelClass(item.is_dispatched)" v-html="getDispatchStatus(item.is_dispatched)"></span>
            </td>

            <td>
              <i v-if="item.is_dispatched === '0'" @click="editDetails(item.id)" class="fa fa-edit" aria-hidden="true"></i>
              <i @click="viewDetails(item.id)" class="fa fa-eye action-icon" aria-hidden="true"></i>
            </td>
          </tr>
          <tr v-if="!bootstraplist || bootstraplist.length === 0">
            <td colspan="4" class="text-center">No data available</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!--popup modal-->
  <div v-if="showPopup" class="modal">
    <div class="popup-content">
      <div class="popup-header">
        <h3>Stock Allocation Details</h3>
        <button @click="closePopup" class="close-btn">&times;</button>
      </div>

      <div v-if="loadingPopup" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>
      <div v-else>
        <ul>
          <li>
            <strong>Stock Allocation No:</strong> {{ selectedOrder.stock_allocations_no }}<br />
            <strong>Date:</strong> {{selectedOrder.created_at }}<br />
            <strong>DSR or Vehicle:</strong> {{ selectedOrder.business_name || selectedOrder.first_name + ' ' + selectedOrder.last_name }}
          </li>
        </ul>

        <table class="table">
          <thead>
          <tr>
            <th>Item Name</th>
            <th>Quantity</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in orderDetails" :key="index">
            <td>{{ item.item_name }}</td>
            <td>{{ parseInt(item.qty) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from 'vue';
import { fetchAllocationList, fetchStockAllocationPopup } from '@/services/dataService';

const router = useRouter();
const bootstraplist = ref([]);

const profileId = ref(localStorage.getItem('profile_id'));
const userRole = localStorage.getItem('user_label');
const token = ref(localStorage.getItem('token_set') || '');
const allocationDetails = ref([]);
const showModal = ref(false);
const startDate = ref('');
const initialLoad = ref(true);
const loading = ref(false);
const selectedOrder = ref({});
const orderDetails = ref([]);
const showPopup = ref(false);
const loadingPopup = ref(false);

const newStockAllocation = () => {
  router.push({ path: '/new-stock-allocation' });
};

const getDispatchStatus = (status) => {
  if (status === '1') {
    return '<span class="status-yes">Confirmed</span>';
  }
  return '<span class="status-no">Pending</span>';
};

const getStatusLabelClass = (status) => {
  return status === '1' ? 'status-label status-yes' : 'status-label status-no';
};

const loadStockAllocations = async (date) => {
  try {
    loading.value = true;
    bootstraplist.value = [];
    const payload = {
      created_by: profileId.value,
      date: date || new Date().toISOString().split('T')[0]
    };
    const response = await fetchAllocationList(profileId.value, token.value, payload);
    if (response.data.status === 'failed') {
      console.log(response.data.message);
    } else {
      bootstraplist.value = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching stock allocations:", error);
  } finally {
    loading.value = false;
  }
};

const performSearch = () => {
  initialLoad.value = false;
  loadStockAllocations(startDate.value);
};

const viewDetails = async (id) => {
  try {
    loadingPopup.value = true;
    const response = await fetchStockAllocationPopup(id, token.value);
    selectedOrder.value = response.data.data.stock_allocation;
    orderDetails.value = response.data.data.items;
    showPopup.value = true;
  } catch (error) {
    console.error("Error fetching stock allocation details:", error);
  } finally {
    loadingPopup.value = false;
  }
};

const editDetails = (id) => {
  router.push({ path: `/edit-stock-allocation/${id}` });
};

const closePopup = () => {
  showPopup.value = false;
};

const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

onMounted(async () => {
  try {
    startDate.value = getCurrentDate();
    loadStockAllocations(startDate.value);
  } catch (error) {
    console.error("Initialization failed:", error);
  }
});
</script>

<style scoped lang="scss">
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.search-input[type="date"] {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  width: 100%;
}

.search-input[type="date"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.search-input[type="date"]:hover {
  border-color: #0056b3;
}

.date-grid {
  display: grid;
  grid-template-rows: auto auto;
  gap: 5px;
  font-weight: bold;
}

.date-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.date-search-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-search-container .search-input {
  flex: 1;
  margin-right: 10px;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  transition: color 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}

.action-icon {
  margin-right: 10px;
}

.new-stock-allocation-btn {
  margin-left: auto;
  padding: 10px 20px;
}

.status-label {
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
}

.status-yes {
  background-color: #069E27;
  color: #fff;
  border-radius: 4px;
}

.status-no {
  background-color: red;
  color: #fff;
  border-radius: 4px;
}

</style>